(function () {

  'use strict';

  angular.module('sempraWebapp').service('subsystemService', subsystemService);

  /** @ngInject */
  function subsystemService() {
      this.check = function (json) {
        var data = [];
          json.points.forEach(function(item){
              data.push(item.pointType);  
          });
          return data.indexOf('SUBSYSTEM');
      };
  }
})();
